export const useUnitTypeLabel = (type: { en: string } | null | undefined): string | null => {
  if (!type?.en?.length) return null

  const { t } = useI18n()
  const normalizedType = type.en.toLowerCase().trim().replace(/\s+/g, '_')
  const translationKey = `property.unitTypes.${normalizedType}`
  const translated = t(translationKey)

  if (translated === translationKey) {
    return type.en
  }

  return translated
}

